// extracted by mini-css-extract-plugin
export var avatar = "_qf-3";
export var avatarContainer = "_qf-2";
export var avatarSpacer = "_qf-5";
export var avatarSpacerContainer = "_qf-4";
export var avatarStackContainer = "_qf-1";
export var bubble = "_qf-0";
export var remainderBubble = "_qf-6";